module.exports = __webpack_public_path__ + "static/media/key-profile.b086e691.png";